import Vue from 'vue'

export default {

    /**
     * Set tasks
     * @param state
     * @param nodekpis
     * @constructor
     */
    SET_NODEKPIS(state, nodekpis) {

        // Tasks can be a single task or tasks list
        if (!Array.isArray(nodekpis)) nodekpis = [nodekpis];

        // Save each task from list to state
        nodekpis.forEach(i => {

            // Check is task deleted
            if(i.deleted_at)
            {
                // Delete task
                Vue.delete(state.nodekpis, i.id);
            }
            else {
                // Store task
                Vue.set(state.nodekpis, i.id, i);
            }
        });
    },

    /**
     * Set tasks
     * @param state
     * @param nodekpivalues
     * @constructor
     */
    SET_NODEKPI_VALUES(state, nodekpivalues) {

        // Tasks can be a single task or tasks list
        if (!Array.isArray(nodekpivalues)) nodekpivalues = [nodekpivalues];

        // Save each task from list to state
        nodekpivalues.forEach(i => {

            // Check is task deleted
            if(i.deleted_at)
            {
                // Delete task
                Vue.delete(state.nodekpivalues, i.id);
            }
            else {
                // Store task
                Vue.set(state.nodekpivalues, i.id, i);
            }
        });
    },

    /**
     * Delete nodekpi values
     * @param state
     * @param nodekpivalues
     * @constructor
     */
    DELETE_NODEKPI_VALUES(state, nodekpivalues) {

        // Tasks can be a single task or tasks list
        if (!Array.isArray(nodekpivalues)) nodekpivalues = [nodekpivalues];

        // Save each task from list to state
        nodekpivalues.forEach(i => {
            Vue.delete(state.nodekpivalues, i.id);
        });
    },

    /**
     * Delete nodekpis
     * @param state
     * @param nodekpis
     * @constructor
     */
    DELETE_NODEKPIS(state, nodekpis) {

        // Tasks can be a single task or tasks list
        if (!Array.isArray(nodekpis)) nodekpis = [nodekpis];

        // Save each task from list to state
        nodekpis.forEach(i => {
            Vue.delete(state.nodekpis, i.id);
        });
    },
}
